import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import HPButton from "@/components/common/Button";
import type { ScorecardQuestionRow } from "@/models/Scorecard";

interface DependentRowsDeleteDialogProps {
  open: boolean;
  rowLabel: string;
  dependentRows: ScorecardQuestionRow[];
  onCancel: () => void;
  onConfirm: () => void;
}

/** Confirms deleting a Question row that other rows use as their Scorecard
 *  Row Base — lists the dependents so the researcher knows they'll need
 *  a replacement Base afterward. */
const DependentRowsDeleteDialog: React.FC<DependentRowsDeleteDialogProps> = ({
  open,
  rowLabel,
  dependentRows,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Delete &quot;{rowLabel}&quot;?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          The following {dependentRows.length === 1 ? "row uses" : "rows use"}{" "}
          this row as its Scorecard Row Base and will need a new Base after
          deletion:
        </Typography>
        <List dense sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, py: 0 }}>
          {dependentRows.map((row) => (
            <ListItem key={row.id} sx={{ py: 0.5 }}>
              <Box>
                <Typography variant="body2" fontWeight={500}>
                  {row.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {row.sourceQuestionLabel}
                </Typography>
              </Box>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <HPButton variant="text" onClick={onCancel}>
          Cancel
        </HPButton>
        <HPButton variant="contained" color="error" onClick={onConfirm}>
          Delete anyway
        </HPButton>
      </DialogActions>
    </Dialog>
  );
};

export default DependentRowsDeleteDialog;
